var $ = require('jquery');
var fg = require('../../base');
var Component = require('../../component');


/**
 * @author RCH, issue#60227
 * @param props {Object}
 * @constructor
 */
var TargetBlankAutoTitle = function(props) {
  Component.call(this, props);
};

fg.inherits(TargetBlankAutoTitle, Component);

/**
 * @type {string}
 */
TargetBlankAutoTitle.COMPONENT_NAME = 'targetBlankAutoTitle';

/**
 *
 * @override
 */
TargetBlankAutoTitle.prototype.getDefaultProps = function(){
  return {
    labels: {
      "cs": "Odkaz se otevře v novém okně",
      "sk": "Odkaz sa otvorí v novom okne",
      "en": "Link opens in a new window",
      "en-GB": "Link opens in a new window",
      "en-US": "Link opens in a new window",
      "de": "Link im neuen Fenster öffnen",

      "bg": "Отваря се връзката в нов прозорец",
      "es": "El enlace se abre en una nueva ventana",
      "da": "Link åbner i et nyt vindue",
      "et": "Link avaneb uues aknas",
      "el": "Ο σύνδεσμος ανοίγει σε νέο παράθυρο",
      "fr": "Lien ouvre dans une nouvelle fenêtre",
      "ga": "Osclaíonn an nasc i bhfuinneog nua",
      "hr": "Link se otvara u novom prozoru",
      "it": "Link si apre in una nuova finestra",
      "lv": "Saite atveras jaunā logā",
      "lt": "Nuoroda atsidaro naujame lange",
      "hu": "Hivatkozás megnyit egy új ablakban",
      "mt": "Link jiftaħ tieqa ġdida",
      "nl": "Link opent in een nieuw venster",
      "pl": "Otwiera link w nowym oknie",
      "pt": "O link se abre em uma nova janela",
      "ro": "Link deschide într-o fereastră nouă",
      "sl": "Povezava se odpre v novem oknu",
      "fi": "Linkki avautuu uuteen ikkunaan",
      "sv": "Länken öppnas i ett nytt fönster",
      "ru": "Ссылка откроется в новом окне"
    }
  }
};

TargetBlankAutoTitle.prototype.affectedElements_ = [];

TargetBlankAutoTitle.prototype.getPageLang = function(){
  return $("html").attr("lang") || "en";
};

TargetBlankAutoTitle.prototype.getUniqueComponentInstanceId = function(){
  return this.constructor.COMPONENT_NAME + this.getId();
};

/**
 *
 * @override
 */
TargetBlankAutoTitle.prototype.enterDocument = function(){
  this.constructor.superClass_.enterDocument.call(this);

  this.bindEvents();
};

TargetBlankAutoTitle.prototype.bindEvents = function(){
  var t = this;
  this.element.on("mouseover."+this.getUniqueComponentInstanceId(), "a[target='_blank']", function(){
    t.setTitleIfIsEmptyAndNotSetYet($(this));
  });
};

TargetBlankAutoTitle.prototype.unbindEvents = function(){
  var t = this;
  this.element.off("mouseover."+this.getUniqueComponentInstanceId());
};

/**
 *
 * @param {jQuery | Element} element
 */
TargetBlankAutoTitle.prototype.setTitleIfIsEmptyAndNotSetYet = function(element) {
  if (!element.data("hasAutoTitle")) {

    if (!element.attr("title")) {
      this.setTitle_(element);
      this.affectedElements_.push(element);
    }
  }
};

/**
 *
 * @param {jQuery | Element} element
 * @private
 */
TargetBlankAutoTitle.prototype.setTitle_ = function(element) {
  element.attr("title", this.getTitleCorrespondingToLang());
  element.data("hasAutoTitle", true);
};

/**
 *
 * @returns {string}
 */
TargetBlankAutoTitle.prototype.getTitleCorrespondingToLang = function(){
  return this.props.labels[this.getPageLang()];
};

/**
 *
 * @override
 */
TargetBlankAutoTitle.prototype.dispose = function() {
  this.unbindEvents();
  this.resetTitlesOnAffectedElements_();
  this.constructor.superClass_.dispose.call(this);
};

/**
 * @private
 */
TargetBlankAutoTitle.prototype.resetTitlesOnAffectedElements_ = function(){
  $(this.affectedElements_).each(function(i, item){
    item.attr("title", "");
  });
};


fg.makeJQueryPlugin(TargetBlankAutoTitle);

module.exports = TargetBlankAutoTitle;



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/plugins/required/targetBlankAutoTitle.js